module.exports = __webpack_public_path__ + "static/grzesiak_main_2-afb901314097b6ef1b8d670c93ade0a6.png";